<template>
    <div class="container-fluid">
        <div class="row">
            <nav class="navbar navbar-expand-lg navbar-light bg-light  fixed-top">
                <a class="navbar-brand d-flex align-items-center" href="#" @click="goPage('/')">
                    <img class="logo-img" src="../assets/images/logo/logo.png">
                    <div class="logo-title">渥康<span class="R"> ®</span></div>
                </a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                    <ul class="navbar-nav pull-right">
                        <li v-for="(item,index) in navList" :key="index" class="nav-item" @click="goPage(item.path,item.id)">
                            <a class="nav-link" :class="item.class" aria-current="page">{{item.title}}</a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
        <div class="cover"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            nabidx: null,
            navList: [
                {
                    id: 0,
                    title: "首页",
                    path: "/",
                    class: "active",
                },
                {
                    id: 1,
                    title: "关于渥康",
                    path: "/AboutWDOM",
                    class: "",
                },
                {
                    id: 2,
                    title: "渥康产品",
                    path: "/ProductList",
                    class: "",
                },
                {
                    id: 3,
                    title: "渥康品质",
                    path: "/QualityWDOM",
                    class: "",
                },
                {
                    id: 4,
                    title: "分享专栏",
                    path: "/myCardShare",
                    class: "",
                },
            ],
        };
    },
    methods: {
        goPage(path) {
            this.$router.push({
                path: path,
            });
        },
        setNavState(path) {
            for (let i in this.navList) {
                this.navList[i].class = "";
                if (path == this.navList[i].path) {
                    this.navList[i].class = "active";
                }
            }
        },
    },
    computed: {
        pathName() {
            return this.$store.state.pathName;
        },
    },
    watch: {
        pathName(path) {
            this.setNavState(path);
        },
    },
};
</script>

<style scoped>
.cover {
    height: 56px;
    width: 100%;
    top: 0;
}
/* .logo {
    margin-left: 120px;
} */
.logo-img {
    width: 60.53px;
    height: 16px;
}
.logo-title {
    font-size: 16px;
    margin-left: 10px;
}
.navbar-light {
    background-color: white !important;
    border-bottom: 1px solid rgba(218, 218, 218, 1);
}
.R{
    font-size: 10px;
    position: relative;
    bottom: 3px;
}
@media (min-width: 975px) {
    .navbar-light .navbar-nav .show > .nav-link,
    .navbar-light .navbar-nav .nav-link.active {
        color: rgba(51, 51, 51, 1);
        cursor: pointer;
    }
    .navbar-light .navbar-nav .nav-link {
        cursor: pointer;
    }
}
@media (min-width: 975px) {
    .navbar-light .navbar-nav .show > .nav-link,
    .navbar-light .navbar-nav .nav-link.active {
        color: rgba(51, 51, 51, 1);
        border-bottom: 1px solid rgba(102, 102, 102, 1);
        cursor: pointer;
    }
    .navbar-light .navbar-nav .nav-link {
        cursor: pointer;
    }
}
</style>